export const trim = (s: string) => s.trim();

export const BASE_URL = "https://api.alumnify.v2nportal.com/api/";

export const INVITE_URL = "https://alumnify.v2nportal.com/invitations/accept";
// export const INVITE_URL = "http://localhost:3000/invitations/accept";
export const RESET_PASSWORD_URL =
  "https://alumnify.v2nportal.com/reset-password;";
// export const RESET_PASSWORD_URL = "http://localhost:3000/reset-password";

export const validateDOB = (dob: string): string | undefined => {
  if (!dob) return "Date of birth is required";

  const today = new Date();
  const birthDate = new Date(dob);
  const age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  const adjustedAge =
    monthDiff < 0 || (monthDiff === 0 && dayDiff < 0) ? age - 1 : age;

  if (adjustedAge < 18) return "You must be at least 18 years old";
  if (birthDate > today) return "Date of birth cannot be in the future";
  return undefined;
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
};

export const formatTimeAgo = (dateString: string): string => {
  const now = Date.now();
  const past = new Date(dateString).getTime();
  const diff = Math.floor((now - past) / 1000);

  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  if (diff < 31536000) return `${Math.floor(diff / 2592000)}mo ago`;
  return `${Math.floor(diff / 31536000)}y ago`;
};
